import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${p =>
    !p.$showTagText &&
    `
    display: grid;
    grid-template-columns: repeat(3, auto);
    justify-content: start;
  `};
  ${media.small`
      grid-template-columns: repeat(4, auto);
  `};
`;

export const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  &:hover label {
    visibility: visible;
  }
`;

export const TagImage = styled.img`
  position: relative;
  width: ${p => (p.$showTagText ? '2.4rem' : '2.3rem')};
  height: ${p => (p.$showTagText ? '2.4rem' : '2.3rem')};
  margin: 0.3rem;
  &:last-child {
    margin-right: ${p => (p.$showTagText ? '2rem' : '0.3rem')};
  }
  &:only-child {
    margin-right: 0;
  }
  ${media.small`
    width: ${p => (p.$showTagText ? '2rem' : '2.4rem')};
    height: ${p => (p.$showTagText ? '2rem' : '2.4rem')};
  `};
`;

export const TagTooltip = styled.label`
  font-size: 1.2rem;
  white-space: nowrap;
  padding: ${p => (p.$showTagText ? '0 0.5rem' : '0.5rem 0.75rem')};
  color: ${p =>
    p.$showTagText ? p.theme.primaryColor : p.theme.primaryTextColor};
  background-color: ${p => (p.$showTagText ? 'none' : p.theme.primaryBgColor)};
  position: ${p => (p.$showTagText ? 'relative' : 'absolute')};
  left: ${p => (p.$showTagText ? 'initial' : '50%')};
  bottom: ${p => (p.$showTagText ? 'initial' : '100%')};
  transform: ${p => (p.$showTagText ? 'none' : 'translateX(-50%)')};
  margin-bottom: ${p => (p.$showTagText ? '0' : '0.4rem')};
  border-radius: 0.4rem;
  z-index: 2;
  visibility: ${p => (p.$showTagText ? 'visible' : 'hidden')};
`;
